module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-choice-wrapper",
    class: _vm.wrapperClasses
  }, [(_vm.showDonateType) ? _c('product-donate-type', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.donateType),
      callback: function($$v) {
        _vm.donateType = $$v
      },
      expression: "donateType"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-donate-choice"
  }, [_vm._l((_vm.config.choices), function(choice) {
    var _obj;

    return _c('div', {
      staticClass: "donate-item",
      class: ( _obj = {
        active: _vm.amount == choice && _vm.amount > 0
      }, _obj[_vm.classes] = true, _obj )
    }, [_c('label', {
      staticClass: "btn"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.amount),
        expression: "amount"
      }],
      attrs: {
        "type": "radio",
        "name": "amount"
      },
      domProps: {
        "value": choice,
        "checked": _vm._q(_vm.amount, choice)
      },
      on: {
        "change": function($event) {
          _vm.amount = choice
        }
      }
    }), _vm._v(" " + _vm._s(_vm._f("comma")(choice)) + " บาท\n      ")])])
  }), _vm._v(" "), (_vm.custom && _vm.showCustomAmountButton) ? _c('div', {
    staticClass: "donate-item donate-item--custom",
    class: ( _obj = {
      active: _vm.isCustomAmountActive
    }, _obj[_vm.classes] = true, _obj )
  }, [_c('label', {
    staticClass: "btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "radio",
      "name": "amount"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.amount, 0)
    },
    on: {
      "change": function($event) {
        _vm.amount = 0
      }
    }
  }), _vm._v(" ระบุจำนวน\n      ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.custom && _vm.amount === 0) ? _c('div', {
    staticClass: "donate-item-amount",
    class: {
      active: _vm.amount === 0
    }
  }, [_c('label', [_vm._v("\n      ระบุจำนวนเงิน (บาท)\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "radio",
      "name": "amount",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.amount, "0")
    },
    on: {
      "change": function($event) {
        _vm.amount = "0"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customAmount),
      expression: "customAmount"
    }],
    ref: "inputCustomAmount",
    staticClass: "form__text",
    attrs: {
      "type": "number",
      "placeholder": "หรือระบุจำนวนเงินตามใจคุณ",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "focus": _vm.customAmountFocus,
      "keyup": _vm.customAmountKeyUp,
      "blur": _vm.customAmountUnfocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['customAmount'].minimum),
      expression: "$v.$errors['customAmount'].minimum"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("จำนวนเงินขั้นต่ำ " + _vm._s(_vm.product.originalPrice) + " บาท")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e201ae4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDonateChoice.vue
// module id = 1205
// module chunks = 0